<div class="container" *ngLet="{
  loadingInitTable: loadingInitTable$ | async,
  isFirstColumnPinned: isFirstColumnPinned$ | async,
} as async">
  <div *ngLet="breakPointObserve$ | async as breakPointScreen" class="data-container">
    <div
      *ngLet="selectCatalog$ | async as selectCatalog"
      [ngStyle]="{
        width: (showSelectedItemInfo && !async.loadingInitTable | tableResponsiveWidth : breakPointScreen),
        display: 'flex'
      }"
      class="left"
    >
      <div class="header" [ngClass]="{ 'disabled-header': async.loadingInitTable }">
        <div class="first-header" *ngLet="clickRecommendation$ | async">
          <span [ngClass]="{ 'element-disabled': isNotPublicCatalog }">
            <mat-checkbox
              [disabled]="isNotPublicCatalog"
              *ngIf="!isDynamic"
              [matTooltip]="'DATA.CATALOG_ITEMS_DATA.HEADER.RECOMMENDED' | translate"
              class="recommended"
              [(ngModel)]="isRecommendationData"
              (click)="getRecommendationClick(!isRecommendationData)"
              >{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.RECOMMENDED' | translate }}</mat-checkbox
            >
          </span>
          <div [formGroup]="form" *ngIf="selectCatalog?.hasGeo" class="container__next-me" [ngClass]="{ 'element-disabled': isNotPublicCatalog }">
            <mat-checkbox
              [disabled]="isNotPublicCatalog"
              [matTooltip]="'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate"
              class="nearby"
              formControlName="isNextMeData"
              >{{ 'DATA.CATALOG_ITEMS_DATA.HEADER.NEARBY' | translate }}</mat-checkbox
            >
            <div class="input__container">
              <input
                [disabled]="isNotPublicCatalog"
                (keydown.enter)="nextMeDataLoading()"
                [matTooltip]="'OTHER.RADIUS' | translate"
                formControlName="radius"
                class="input__next-me"
                placeholder="2000"
                type="number"
              />
              <div class="buttons-wrapper">
                <button [disabled]="disableSearchNextToMeData" class="btn-empty search-btn" (click)="nextMeDataLoading()">
                  <svg [icon]="icons.Search" [matTooltip]="'DATA.TABLE_FILTER.SEARCH' | translate" class="svg24 inactive-color search-icon" />
                </button>
              </div>
            </div>
          </div>

          <app-search-filter
            #searchFilterComponent
            (changedFilter)="changeFilter($event)"
            [overlayPosition]="overlayPosition"
            [allFields]="allColumns"
          ></app-search-filter>

          <div class="columns-mobile-filter">
            <app-column-filter
              [matTooltip]="'SEARCH.TABLE.ATTRIBUTE' | translate"
              [isPinned]="async.isFirstColumnPinned || false"
              [selectColumns]="dynamicColumnOptions"
              (changeColumn)="addTableRight()"
              (changeColumnPinned)="pinColumn($event)"
            ></app-column-filter>
          </div>
        </div>
        <app-dynamic-update-info></app-dynamic-update-info>
      </div>
      <div class="tables" *ngIf="(catalogItemsData$ | async) && !dataSourceLoading && !async.loadingInitTable" #table>
        <ng-container *ngIf="this.dataSource?.data?.length; else noData">
        <ng-container *ngLet="fileData$ | async as allFilesData">
          <div
            class="static-table"
            #staticTable
            *ngIf="async.isFirstColumnPinned"
            (scroll)="staticScrollChange($event)"
          >
            <table
              mat-table
              [dataSource]="dataSource"
              [trackBy]="trackRow"
              [style.width]="staticColumns | staticTableWidth : dataSource.data : fileColumnNames : breakPointScreen"
            >
              <ng-container *ngFor="let column of staticColumns; let ix = index; let lastRow = last">
                <ng-container matColumnDef="{{ column?.name }}">
                  <th mat-header-cell
                      *matHeaderCellDef
                      class="{{ lastRow ? 'last' : 'first' }}"
                      [style.width]="column | firstStaticColumnWidth : dataSource.data : fileColumnNames : (ix === 1) : breakPointScreen"
                      [style.max-width]="column | firstStaticColumnWidth : dataSource.data : fileColumnNames : (ix === 1) : breakPointScreen"
                  >
                    <div [class.first-static-column]="!lastRow">
                      <div
                        [matTooltip]="toolTipText(column.title)"
                        [ngClass]="{ 'last-static-header': lastRow }"
                        [innerHTML]="column.title"
                      ></div>
                      <ng-container *ngIf="lastRow">
                        <app-column-filter
                          [matTooltip]="'SEARCH.TABLE.ATTRIBUTE' | translate"
                          [isPinned]="async.isFirstColumnPinned || false"
                          [selectColumns]="dynamicColumnOptions"
                          (changeColumn)="addTableRight()"
                          (changeColumnPinned)="pinColumn($event)"
                        ></app-column-filter>
                      </ng-container>
                    </div>
                  </th>
                  <td mat-cell
                      *matCellDef="let element"
                      [style.width]="column | firstStaticColumnWidth : dataSource.data : fileColumnNames : (ix === 1) : breakPointScreen"
                      [style.max-width]="column | firstStaticColumnWidth : dataSource.data : fileColumnNames : (ix === 1) : breakPointScreen"
                  >
                    <div style="overflow: unset"
                         *ngIf="element">
                      <div style="overflow: unset">
                        <div [class.center]="lastRow" [class.index-column]="!lastRow">
                          <div class="vertical-menu-mobile-wrapper" style="overflow: unset" *ngIf="!lastRow">
                            <app-more-vert-menu
                              *ngIf="!selectCatalog.archive && !isNotPublicCatalog"
                              [element]="element"
                              [menuItems]="menuItems"
                              class="favorites"
                            ></app-more-vert-menu>
                          </div>

                          <ng-container *ngIf="column.type === 'FILE'; else textCell">
                            <app-download-link-list
                              [fileIds]="element[column.name]"
                              [allFiles]="allFilesData"
                              [width]="column | staticColumnWidth : dataSource.data : fileColumnNames : (ix === 1) : breakPointScreen"
                              (onRowClick)="setSelectedItem($event?.target || null, element)"
                            ></app-download-link-list>
                          </ng-container>

                          <ng-template #textCell>
                            <div
                              [class.link-3]="column.type === linkType"
                              [matTooltip]="toolTipText(column.type === 'LINK' ? element[column.name].value : element[column.name])"
                            >
                              {{ column.type === 'LINK' ? element[column.name].value : element[column.name] }}
                              <ng-container *ngIf="element[column.name] && element[column.name].constructor.name === 'Array' && element[column.name].length">
                                <span class="array-cell">
                                    <span class="text-block">{{element[column.name][0].value}}</span>
                                    <span class="count" *ngIf="element[column.name].length >=2">...&nbsp;и&nbsp;еще&nbsp;{{+element[column.name].length - 1}}</span>
                                </span>
                              </ng-container>
                            </div>
                          </ng-template>

                          <div class="vertical-menu-wrapper" style="overflow: unset" *ngIf="lastRow">
                            <app-more-vert-menu
                              *ngIf="!selectCatalog.archive && !isNotPublicCatalog"
                              [element]="element"
                              [menuItems]="menuItems"
                              class="favorites"
                            ></app-more-vert-menu>
                            <svg
                              *ngIf="selectCatalog.archive"
                              class="svg24"
                              [matTooltip]="'DATA.SHARED.MORE_VERT_MENU.COPY_LINK' | translate"
                              [icon]="icons.Links"
                              (click)="copyLink(element)"
                            ></svg>
                          </div>
                        </div>
                      </div>
                    </div>
                  </td>
                </ng-container>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="staticColumnsName; sticky: true"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: staticColumnsName"
                [ngStyle]="{ background: selectCatalogItemId === row?.global_id ? '#f3f5f7' : '' }"
                (click)="setSelectedItem($event.target, row)"
                [ngClass]="{ hov: hoverGlobalId === row?.global_id }"
                (mouseenter)="changeRowHover($event, row?.global_id)"
                (mouseleave)="changeRowHover($event, row?.global_id)"
              ></tr>
            </table>
          </div>

          <div
            *ngIf="showBorder$ | async"
            class="table-right-border"
            [style.height]="borderHeight"
          ></div>

          <div
            class="dynamic-table"
            #dynamicTable
            (scroll)="dynamicScrollChange($event)"
          >
            <table
              mat-table
              [dataSource]="dataSource"
              [trackBy]="trackRow">
              <ng-container *ngFor="let column of dynamicColumns; let firstRow = first">
                <ng-container matColumnDef="{{ column?.name }}">
                  <th [hidden]="!column?.isSelected"
                      mat-header-cell
                      *matHeaderCellDef>
                    <div [style.width]="column | dynamicColumnWidth : dataSource.data : fileColumnNames : breakPointScreen"
                         [style.justify-content]="firstRow && !async.isFirstColumnPinned ? 'center' : 'flex-start'"
                         [class.first-dynamic-column]="isFirstDynamicColumn(column)">
                      <div
                        [matTooltip]="toolTipText(column.title)"
                        class="dynamic-column"
                        [innerHTML]="column?.title"
                      ></div>
                    </div>
                  </th>
                  <td [hidden]="!column?.isSelected"
                      mat-cell
                      *matCellDef="let element">
                    <div class="cell-wrapper">
                      <ng-container *ngIf="isFirstDynamicColumn(column) && !async.isFirstColumnPinned">
                        <div class="vertical-menu-mobile-wrapper" style="overflow: unset">
                          <app-more-vert-menu
                            *ngIf="!selectCatalog.archive && !isNotPublicCatalog"
                            [element]="element"
                            [menuItems]="menuItems"
                            class="favorites"
                          ></app-more-vert-menu>
                        </div>
                      </ng-container>
                      <div *ngIf="element && column?.isSelected">
                        <ng-container *ngIf="column?.isFile; else text">
                          <app-download-link-list
                            [fileIds]="element[column.name]"
                            [allFiles]="allFilesData"
                            [width]="column | dynamicColumnWidth : dataSource.data : fileColumnNames : breakPointScreen"
                            (onRowClick)="setSelectedItem($event?.target || null, element)"
                          ></app-download-link-list>
                        </ng-container>

                        <ng-template #text>
                          <div *ngIf="element[column.name] || element[column.name] === 0">
                            <div
                              [style.width]="column | dynamicColumnWidth : dataSource.data : fileColumnNames : breakPointScreen"
                              [class.index-column]="firstRow && !async.isFirstColumnPinned"
                              [class.link-3]="column.isLink"
                              [matTooltip]="toolTipText(column.isLink ? element[column.name].value : element[column.name])"
                            >
                              <span (click)="column.isLink ? openLinkCard(element[column.name], column) : ''">{{ column.isLink ? element[column.name].value : element[column.name] }}</span>
                              <ng-container *ngIf="element[column.name].constructor.name === 'Array' && element[column.name].length">
                                <span class="array-cell" (click)="openArrayCard(element[column.name], column)">
                                  <span class="text-block">{{element[column.name][0].value}}</span>
                                  <span class="count" *ngIf="element[column.name].length >=2">...&nbsp;и&nbsp;еще&nbsp;{{+element[column.name].length - 1}}</span>
                                </span>
                              </ng-container>
                            </div>
                          </div>
                        </ng-template>
                      </div>
                    </div>
                  </td>
                </ng-container>
              </ng-container>
              <!--      <ng-container matColumnDef="favorites">
                <th mat-header-cell *matHeaderCellDef></th>
                <td mat-cell *matCellDef="let element" class="more-menu">
                  <app-more-vert-menu
                    *ngIf="!selectCatalog.archive && !isNotPublicCatalog"
                    [element]="element"
                    [menuItems]="menuItems"
                    class="favorites"
                  ></app-more-vert-menu>
                  <svg
                    *ngIf="selectCatalog.archive"
                    class="svg24"
                    [matTooltip]="'DATA.SHARED.MORE_VERT_MENU.COPY_LINK' | translate"
                    [icon]="icons.Links"
                    (click)="copyLink(element)"
                  ></svg>
                </td>
              </ng-container>-->

              <tr mat-header-row *matHeaderRowDef="dynamicColumnsName; sticky: true"></tr>
              <tr
                mat-row
                *matRowDef="let row; columns: dynamicColumnsName"
                [ngStyle]="{ background: selectCatalogItemId === row?.global_id ? '#f3f5f7' : '' }"
                (click)="setSelectedItem($event.target, row)"
                [ngClass]="{ hov: hoverGlobalId === row?.global_id }"
                (mouseenter)="changeRowHover($event, row?.global_id)"
                (mouseleave)="changeRowHover($event, row?.global_id)"
              ></tr>
            </table>
          </div>
        </ng-container>
        </ng-container>
      </div>

      <div class="paginator-container" [hidden]="hidePagination || (isFatalError$ | async) || async.loadingInitTable">
        <app-mat-pagination-custom [allCount]="staticCountRows" (pageEvent)="paginatorChange($event)"></app-mat-pagination-custom>
      </div>

      <app-loader *ngIf="async.loadingInitTable"></app-loader>
    </div>

    <div
      *ngIf="showSelectedItemInfo && !async.loadingInitTable"
      class="right"
    >
      <app-catalog-item-card (closeCard)="showSelectedItemInfo = false; addTableRight()"></app-catalog-item-card>
    </div>
  </div>
  <app-dynamic-update-info [isMobile]="true" class="mobile-dynamic-info"></app-dynamic-update-info>
</div>

<ng-template #isError>
  <div class="not-found">
    <app-error-page-message
      *ngIf="isFatalError$ | async"
      [icon]="icons.NotAvailable"
      header="APP_ERROR_MESSAGE.DATA_LIST_UNAVAILABLE"
      message="APP_ERROR_MESSAGE.PLEASE_TRY_AGAIN_LATER"
      class="fatal-error"
    >
      <div class="btn-group">
        <a class="btn-primary medium td-n" (click)="reloadPage()">{{ 'APP_ERROR_MESSAGE.CHECK_AGAIN' | translate }}</a>
        <a class="btn-secondary medium td-n" href="/">{{ 'OTHER.TO_HOME' | translate }}</a>
      </div>
    </app-error-page-message>
  </div>
</ng-template>

<ng-template #noData>
  <div class="not-found" *ngIf="!(isFatalError$ | async); else isError">
    <app-error-page-message
      [icon]="icons.NotFound"
      header="APP_ERROR_MESSAGE.RESPONSE_NOT_FOUND"
      message="APP_ERROR_MESSAGE.TRY_CHANGING_SEARCH_TERMS"
    >
      <button class="btn-secondary medium td-n" (click)="clearFilter()">
        {{ 'OTHER.RESET_ALL' | translate }}
      </button>
    </app-error-page-message>
  </div>
</ng-template>
